export default __webpack_public_path__ + "static/media/bullet-boardgame.83af12b1.webp";